import React, { useContext } from "react";
import { GlobalDataContext } from "../context/context";
import TransparentHeader from "../components/global/TransparentHeader";
import BaseLayout from "../components/global/BaseLayout";
import ValuesOne from "../components/values/Values_4";
import BlockPrincipal from "../components/block/Block_4V";
import BlockSecondary from "../components/block/Block_4";

function About() {
  const { rpdata } = useContext(GlobalDataContext);
  return (
    <BaseLayout PageName="About">
      <div className="md:max-w-full w-full">
        <TransparentHeader
          headertitle="About"
          Subheader="About"
          bgimg={`${rpdata?.stock?.[9]}`}
        />
        <BlockPrincipal
          title={'a little about us'}
          text={rpdata?.dbAbout?.[0]?.text}
          image={rpdata?.stock?.[8]}
          image1={rpdata?.stock?.[0]}
          image3={rpdata?.stock?.[15]}
          image2={rpdata?.stock?.[3]}
          image4={rpdata?.stock?.[7]}
          listsAbout
        />
        <ValuesOne
          image={rpdata?.stock?.[2]}
          image1={rpdata?.stock?.[14]}
          image2={rpdata?.stock?.[15]} />

        <BlockSecondary
          title={rpdata?.dbSlogan?.[2]?.slogan}
          text={rpdata?.dbAbout?.[1]?.text}
          image1={rpdata?.stock?.[2]}
        />
      </div>
    </BaseLayout>
  );
}

export default About;
